import { NotificationManager } from 'react-notifications';

import * as types from './types';
import { RequestAction } from '../../utils/Request';
import termsService from '../../services/TermsService';
import { withLoading } from '../../actions/CommonActions';

export const loadLatest = withLoading(() => {
  return (dispatch) => {
    return dispatch(
      RequestAction(types.TERMS_LATEST, termsService().fetchLatest)
    );
  };
});

export const loadAll = withLoading(() => {
  return (dispatch) => {
    return dispatch(RequestAction(types.TERMS_ALL, termsService().fetchAll));
  };
});

export const save = withLoading((terms, success) => {
  return (dispatch, getState) => {
    const {
      okta: {
        user: { email },
      },
    } = getState();
    const today = new Date().toISOString();
    if (!terms.createdBy) {
      return save(
        {
          ...terms,
          createdBy: email,
          createdOn: today,
          active: true,
        },
        success
      );
    }
    return dispatch(
      RequestAction(types.TERMS_SAVE, termsService().save, {
        ...terms,
        modifiedBy: email,
        modifiedOn: today,
      })
    )
      .then(() => {
        if (success) {
          success();
        }
        dispatch(loadLatest()).then(() => {
          dispatch(loadAll()).then(() => {
            NotificationManager.success(
              'Terms and Conditions successfully saved.',
              'Terms and Conditions'
            );
          });
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Error saving terms and conditions.',
          'Terms and Conditions'
        );
      });
  };
});

export const acceptTermsAndConditions = (accepted) => {
  return (dispatch) => {
    switch (accepted) {
      case true: {
        return dispatch({ type: types.TERMS_ACCEPTED });
      }
      case false: {
        return dispatch({ type: types.TERMS_MUST_ACCEPT });
      }
      default:
        return dispatch({ type: types.TERMS_MUST_ACCEPT });
    }
  };
};

export const shouldReadTermsAndConditions = withLoading(() => {
  return (dispatch) => {
    return dispatch(loadLatest());
  };
});
